import { HTTP } from "./http";

export const LikeService = {
  all() {
    return HTTP.get("/likes");
  },
};
